export default "__VITE_ASSET__D16_Dpk0__"